export default __webpack_public_path__ + "static/media/thumbnail-5.e5824fe6.jpg";